"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.PortraitImageWrapper = exports.LandscapeImageWrapper = exports.SliderItemBox = exports.DescriptionBox = exports.SliderBox = exports.ShowMoreButton = exports.GridBox = exports.StyledTitleBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

var _MediaQueries = _interopRequireDefault(require("../../../../../MediaQueries"));

var _TitleBox = _interopRequireDefault(require("../../../../../Modal/components/TitleBox"));

var _Elements = require("../../../../../Modal/Elements");

var _templateObject, _templateObject2, _templateObject3;

var StyledTitleBox = (0, _styledComponents["default"])(_TitleBox["default"]).withConfig({
  displayName: "Elements__StyledTitleBox",
  componentId: "sc-19xfuzh-0"
})(["background:", ";", "{svg{path{fill:", ";}}}"], function (props) {
  return props.theme.portfolioBackground1;
}, _Elements.ModalCloseButton, function (props) {
  return props.theme.portfolioForeground1;
});
exports.StyledTitleBox = StyledTitleBox;
var GridBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__GridBox",
  componentId: "sc-19xfuzh-1"
})(["box-sizing:border-box;padding-bottom:96px;background:", ";img{transition:all 0.6s;&:hover{transform:scale(1.1);}}"], function (props) {
  return props.theme.portfolioBackground1;
}); // FIXME: Remove font properties from div, refactor

exports.GridBox = GridBox;

var ShowMoreButton = _styledComponents["default"].div.withConfig({
  displayName: "Elements__ShowMoreButton",
  componentId: "sc-19xfuzh-2"
})(["border:2px solid ", ";box-sizing:border-box;width:198px;height:48px;display:flex;align-items:center;justify-content:center;color:", ";font-family:", ";font-style:normal;font-weight:bold;font-size:", ";line-height:", ";", " text-align:center;letter-spacing:0.05em;text-transform:uppercase;margin-top:17px;cursor:pointer;&:hover,&:active{color:", ";border:2px solid ", ";}"], function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme.portfolioFontFamily;
}, function (props) {
  return props.theme.fontSizeBodySmall;
}, function (props) {
  return props.theme.lineHeightBodySmall;
}, _MediaQueries["default"].minWidth.portfolioDesktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.lineHeightBodyLarge;
}), function (props) {
  return props.theme[props.colour];
}, function (props) {
  return props.theme[props.colour];
});

exports.ShowMoreButton = ShowMoreButton;
var SliderBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__SliderBox",
  componentId: "sc-19xfuzh-3"
})(["height:100%;position:relative;background:", ";padding-bottom:", ";", " .slick-slider,.slick-list,.slick-track{height:100%;}.slick-slide{> div{height:100%;}}.slick-prev{left:48px;z-index:2;&:before{font-size:unset;}}.slick-next{right:48px;&:before{font-size:unset;}}svg{path{fill:", "}}"], function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.theme.spacingLg;
}, _MediaQueries["default"].minWidth.medium(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    padding-bottom: ", ";\n  "])), function (props) {
  return props.theme.spacingXl;
}), function (props) {
  return props.theme.portfolioForeground1;
});
exports.SliderBox = SliderBox;
var DescriptionBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__DescriptionBox",
  componentId: "sc-19xfuzh-4"
})(["width:100%;max-width:656px;"]);
exports.DescriptionBox = DescriptionBox;
var SliderItemBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__SliderItemBox",
  componentId: "sc-19xfuzh-5"
})(["height:100%;display:flex !important;align-items:center;justify-content:center;"]);
exports.SliderItemBox = SliderItemBox;
var LandscapeImageWrapper = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__LandscapeImageWrapper",
  componentId: "sc-19xfuzh-6"
})(["max-width:100%;margin:0 auto;height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;", ""], _MediaQueries["default"].minWidth.xSmall(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    max-width: calc(100% - 192px);\n  "]))));
exports.LandscapeImageWrapper = LandscapeImageWrapper;
var PortraitImageWrapper = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__PortraitImageWrapper",
  componentId: "sc-19xfuzh-7"
})(["width:", ";height:100%;margin:0 auto;display:flex;align-items:center;justify-content:center;flex-direction:column;"], function (props) {
  return props.width ? "".concat(props.width, "px") : '0';
});
exports.PortraitImageWrapper = PortraitImageWrapper;

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Elements__Image",
  componentId: "sc-19xfuzh-8"
})(["max-width:100%;max-height:100%;object-fit:cover;"]);

exports.Image = Image;